import { UnionMap } from '../../../types/union-map';

export interface OldMetadataItemViewModel {
    description: string;
    icon: string;
    key: string;
    primary?: boolean;
    value: React.ReactNode | (() => React.ReactNode);
}

export interface MetadataItemViewModel extends Omit<OldMetadataItemViewModel, 'icon'> {
    icon: JSX.Element;
    isRed?: boolean;
}

export type ShimmeredMetadataItemWidth = 'XSmall' | 'Small' | 'Medium' | 'Large';

export const ShimmeredMetadataItemWidth: UnionMap<ShimmeredMetadataItemWidth> = {
    XSmall: 'XSmall',
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
};

export interface ShimmeredMetadataItemViewModel {
    key: string;
    width?: ShimmeredMetadataItemWidth;
}
